import { Button, Panel, Section, Stack, Text, TextField } from '@/ui';
import { PageShell } from '@/ui/primitives/PageShell';
import type { ReactElement } from 'react';

type OrganisationSettingsContentProps = {
  organisationId: string | null;
  nameValue: string;
  nameDirty: boolean;
  disableUpdate: boolean;
  onNameChange: (value: string) => void;
  onCancel: () => void;
  onUpdate: () => void;
  onDeleteOpen: () => void;
};

export const OrganisationSettingsContent = ({
  organisationId,
  nameValue,
  nameDirty,
  disableUpdate,
  onNameChange,
  onCancel,
  onUpdate,
  onDeleteOpen,
}: OrganisationSettingsContentProps): ReactElement => (
  <PageShell maxWidth="sm" paddingX="lg" paddingY="xl" paddingBottom="lg">
    <Stack gap="xl">
      <Section>
        <Stack gap="lg">
          <Text role="pageTitle" component="h1">
            Organisation Settings
          </Text>
          <Panel
            title="Organisation Details"
            actions={
              <>
                <Button
                  variant="ghost"
                  fullWidthOnMobile={false}
                  disabled={!nameDirty || disableUpdate}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disableElevation
                  fullWidthOnMobile={false}
                  disabled={!nameDirty || disableUpdate}
                  onClick={onUpdate}
                >
                  Update
                </Button>
              </>
            }
          >
            <Stack gap="md">
              <Stack gap="xxs">
                <Text role="body" color="textSecondary">
                  Organisation ID
                </Text>
                <Text role="body">{organisationId ?? ''}</Text>
              </Stack>
              <TextField
                label="Organisation Name"
                value={nameValue}
                onChange={(event) => {
                  onNameChange(event.target.value);
                }}
                disabled={disableUpdate}
              />
            </Stack>
          </Panel>
          <Panel title="Organisation Deletion">
            <Stack direction={{ xs: 'column', sm: 'row' }} gap="sm" align={{ sm: 'center' }}>
              <Text role="body" color="textSecondary" sx={{ flex: 1 }}>
                Removes the organisation from your workspace.
              </Text>
              <Button
                variant="destructive"
                fullWidthOnMobile={false}
                disabled={disableUpdate}
                onClick={onDeleteOpen}
              >
                Delete Organisation
              </Button>
            </Stack>
          </Panel>
        </Stack>
      </Section>
    </Stack>
  </PageShell>
);
